import "./northstar-presentation.3cd304bd.js";


function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f7a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f7a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $3fc560b0738cd724$exports = {};
$parcel$extendImportMap({
    "6fYiv": "Telia_Logotype_RGB_Purple.1cab6a79.png",
    "8kxNx": "Eric.27576b5e.png"
});


var $caV3w = parcelRequire("caV3w");

var $iERLf = parcelRequire("iERLf");

var $caV3w = parcelRequire("caV3w");

var $8XEkF = parcelRequire("8XEkF");
/*
 * Telia brand palette — exact values from Telia Brand Hub "Color values":
 *   Deep Purple: #29003E (background dark)
 *   Core Purple: #990AE3 (accent / UI buttons only)
 *   Light Purple: #F4E0FF (text on dark, card bg on light)
 *   Teal: #00827C (info accent)
 */ const $446ae9664652f266$var$TELIA_PURPLE = "#990AE3";
const $446ae9664652f266$var$TELIA_DEEP = "#29003E";
const $446ae9664652f266$var$TELIA_DARK = "#3D1556";
const $446ae9664652f266$var$TELIA_LIGHT = "#F4E0FF";
const $446ae9664652f266$var$TELIA_ACCENT = "#F4E0FF";
const $446ae9664652f266$var$TELIA_MAGENTA = "#C23FE3";
const $446ae9664652f266$var$SECTIONS = [
    "hero",
    "problem",
    "whatIs",
    "uniqueness",
    "roadmap",
    "partners",
    "join"
];
var $316f57c32f6ae9f9$exports = {};
$316f57c32f6ae9f9$exports = $parcel$resolve("6fYiv");


// Logo components using actual brand images
function $446ae9664652f266$var$TeliaLogo({ size: size = 120 }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)("img", {
        src: new URL($316f57c32f6ae9f9$exports),
        alt: "Telia Company Logo",
        style: {
            height: size,
            objectFit: "contain"
        }
    });
}
var $1eac3af024a33683$exports = {};
$1eac3af024a33683$exports = $parcel$resolve("8kxNx");


function $446ae9664652f266$var$EricssonLogo({ size: size = 100 }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)("img", {
        src: new URL($1eac3af024a33683$exports),
        alt: "Ericsson Logo",
        style: {
            height: size,
            objectFit: "contain",
            filter: "brightness(0) invert(1)"
        }
    });
}
function $446ae9664652f266$var$EULogo({ size: size = 60 }) {
    const r = size * 0.38;
    const cx = size / 2;
    const cy = size / 2;
    const stars = [];
    for(let i = 0; i < 12; i++){
        const angle = (i * 30 - 90) * (Math.PI / 180);
        const sx = cx + r * Math.cos(angle);
        const sy = cy + r * Math.sin(angle);
        stars.push(/*#__PURE__*/ (0, $caV3w.jsx)("text", {
            x: sx,
            y: sy,
            textAnchor: "middle",
            dominantBaseline: "central",
            fontSize: size * 0.16,
            fill: "#FFD700",
            children: "\u2605"
        }, i));
    }
    return /*#__PURE__*/ (0, $caV3w.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: `0 0 ${size} ${size}`,
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                cx: cx,
                cy: cy,
                r: r + 4,
                fill: "#003399"
            }),
            stars
        ]
    });
}
// Animated purple wave background
function $446ae9664652f266$var$PurpleWaveBackground({ activeSection: activeSection }) {
    const canvasRef = (0, $8XEkF.useRef)(null);
    const animRef = (0, $8XEkF.useRef)(null);
    const timeRef = (0, $8XEkF.useRef)(0);
    (0, $8XEkF.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        const resize = ()=>{
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        resize();
        window.addEventListener("resize", resize);
        const animate = ()=>{
            timeRef.current += 0.008;
            const t = timeRef.current;
            const w = canvas.width;
            const h = canvas.height;
            // Deep purple gradient base
            const grad = ctx.createLinearGradient(0, 0, w, h);
            grad.addColorStop(0, "#1A0533");
            grad.addColorStop(0.5, "#2D0A4E");
            grad.addColorStop(1, "#1A0533");
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, w, h);
            // Flowing purple waves
            const waveCount = 12;
            for(let i = 0; i < waveCount; i++){
                ctx.beginPath();
                const baseY = h * 0.2 + i * h * 0.06;
                const amplitude = 40 + i * 8;
                const frequency = 0.002 + i * 0.0003;
                const speed = t * (0.5 + i * 0.08);
                const sectionOffset = activeSection * 0.3;
                ctx.moveTo(-10, baseY);
                for(let x = -10; x <= w + 10; x += 4){
                    const y = baseY + Math.sin(x * frequency + speed + sectionOffset) * amplitude + Math.sin(x * frequency * 1.5 + speed * 0.7) * (amplitude * 0.3);
                    ctx.lineTo(x, y);
                }
                ctx.lineTo(w + 10, h + 10);
                ctx.lineTo(-10, h + 10);
                ctx.closePath();
                const alpha = 0.03 + i / waveCount * 0.06;
                const purple = Math.floor(80 + i * 15);
                ctx.fillStyle = `rgba(${purple}, ${Math.floor(10 + i * 5)}, ${Math.floor(140 + i * 10)}, ${alpha})`;
                ctx.fill();
            }
            // Bright accent arc (like the slide's swirl)
            ctx.beginPath();
            const arcX = w * 0.7 + Math.sin(t * 0.3) * 50;
            const arcY = h * 0.3 + Math.cos(t * 0.2) * 30;
            const arcR = Math.min(w, h) * 0.5;
            ctx.arc(arcX, arcY, arcR, -0.8 + Math.sin(t * 0.15) * 0.2, 1.5 + Math.cos(t * 0.1) * 0.3);
            ctx.strokeStyle = `rgba(153, 10, 227, 0.15)`;
            ctx.lineWidth = 60;
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(arcX, arcY, arcR * 0.85, -0.6 + Math.sin(t * 0.12) * 0.15, 1.3);
            ctx.strokeStyle = `rgba(199, 125, 255, 0.08)`;
            ctx.lineWidth = 40;
            ctx.stroke();
            // Floating particles
            for(let i = 0; i < 30; i++){
                const px = (Math.sin(t * 0.3 + i * 47.3) * 0.5 + 0.5) * w;
                const py = (Math.cos(t * 0.2 + i * 31.7) * 0.5 + 0.5) * h;
                const pr = 1 + Math.sin(t + i) * 0.5;
                ctx.beginPath();
                ctx.arc(px, py, pr, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(199, 125, 255, ${0.2 + Math.sin(t + i * 2) * 0.15})`;
                ctx.fill();
            }
            animRef.current = requestAnimationFrame(animate);
        };
        animate();
        return ()=>{
            cancelAnimationFrame(animRef.current);
            window.removeEventListener("resize", resize);
        };
    }, [
        activeSection
    ]);
    return /*#__PURE__*/ (0, $caV3w.jsx)("canvas", {
        ref: canvasRef,
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
            pointerEvents: "none"
        }
    });
}
function $446ae9664652f266$var$Counter({ end: end, suffix: suffix = "", active: active }) {
    const [val, setVal] = (0, $8XEkF.useState)(0);
    (0, $8XEkF.useEffect)(()=>{
        if (!active) {
            setVal(0);
            return;
        }
        let start = 0;
        const step = end / 120;
        const timer = setInterval(()=>{
            start += step;
            if (start >= end) {
                setVal(end);
                clearInterval(timer);
            } else setVal(Math.floor(start));
        }, 16);
        return ()=>clearInterval(timer);
    }, [
        active,
        end
    ]);
    return /*#__PURE__*/ (0, $caV3w.jsxs)("span", {
        children: [
            val,
            suffix
        ]
    });
}
function $446ae9664652f266$var$RoadmapTimeline({ active: active }) {
    const CATEGORIES = [
        {
            id: "orchestration",
            label: "Quality of Service",
            icon: "\uD83D\uDD0C"
        },
        {
            id: "apis",
            label: "Developer APIs",
            icon: "\uD83D\uDCBB"
        },
        {
            id: "location",
            label: "Location-based Services",
            icon: "\uD83D\uDCCD"
        },
        {
            id: "edge",
            label: "Edge Breakout & Compute",
            icon: "\u2601\uFE0F"
        },
        {
            id: "latency",
            label: "Low Latency",
            icon: "\u26A1"
        },
        {
            id: "other",
            label: "Sensing & Satellite",
            icon: "\uD83D\uDEF0\uFE0F"
        }
    ];
    const ROADMAP = {
        "2025": {
            orchestration: [
                "Basic slice/DNN/5QI service modelling"
            ],
            apis: [
                "Quality-on-Demand API",
                "Positioning and tracking API"
            ],
            location: [
                "Indoor dot positioning (~1-2m) incl RedCap",
                "GNSS RTK using 5G SA"
            ],
            edge: [
                "Local breakout deployment"
            ],
            latency: [
                "L4S introduction"
            ],
            other: [
                "SIB9 for 5G time sync"
            ]
        },
        "2026": {
            orchestration: [
                "Advanced lice/DNN/5QI service modelling continues",
                "URSP for Windows, iOS, Android"
            ],
            apis: [
                "Geofencing CAMARA via ENL"
            ],
            location: [
                "Early AI model for indoor positioning (~April)",
                "Outdoor positioning with TA & AoA (~10-50m)",
                "Passive 5G SA outdoor positioning"
            ],
            edge: [
                "Compute edge node integration"
            ],
            latency: [
                "L4S testing by first NorthStar partners"
            ],
            other: [
                "ISAC/Sensing testing at Future by Lund"
            ]
        },
        "2027": {
            orchestration: [
                "New templates for 5GAA and 5G ACIA"
            ],
            apis: [
                "CAMARA Connectivity insights"
            ],
            location: [
                ""
            ],
            edge: [
                "Rollout of +40 distributed AI Compute+Edge Breakout nodes"
            ],
            latency: [
                ""
            ],
            other: [
                "Satellite as backhaul deployment"
            ]
        },
        "2028": {
            orchestration: [
                "Proactive slice assurance"
            ],
            apis: [
                "CAMARA Network slice booking"
            ],
            location: [
                "High-accuracy cross-tech positioning (macro \u2194 indoor \u2194 RTK)"
            ],
            edge: [
                "Edge breakout scaling to 100+ nodes"
            ],
            latency: [
                "TSN for manufacturing and smart grids (Ethernet PDUs) \u2013 5G LAN"
            ],
            other: [
                "Sensing use-case expansion (industrial & defense)",
                "NR NTN, IoT NTN early deployment"
            ]
        },
        "2029": {
            orchestration: [
                "Full proactive assurance"
            ],
            apis: [
                "Expansion to 30+ APIs"
            ],
            location: [
                "Improved positioning using ISAC"
            ],
            edge: [
                "Full NorthStar integration across AI + Edge + RAN"
            ],
            latency: [
                "Further uRLLC enhancements"
            ],
            other: [
                "Mature ISAC ecosystem",
                "Full 5G/Satellite integration",
                "Vertical 5G coverage for aeronautics"
            ]
        }
    };
    const YEAR_COLORS = {
        "2025": $446ae9664652f266$var$TELIA_LIGHT,
        "2026": $446ae9664652f266$var$TELIA_PURPLE,
        "2027": $446ae9664652f266$var$TELIA_MAGENTA,
        "2028": "#FFB74D",
        "2029": "#4DD0E1"
    };
    const yearKeys = Object.keys(ROADMAP);
    const [expandedYear, setExpandedYear] = (0, $8XEkF.useState)(null);
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            width: "100%",
            maxWidth: 900,
            margin: "0 auto"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    gap: 6,
                    marginBottom: 40
                },
                children: yearKeys.map((year, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                        onClick: ()=>setExpandedYear(expandedYear === i ? null : i),
                        style: {
                            flex: 1,
                            cursor: "pointer",
                            transition: "all 0.5s cubic-bezier(0.16,1,0.3,1)",
                            opacity: active ? 1 : 0,
                            transform: active ? "translateY(0)" : `translateY(${40 + i * 15}px)`,
                            transitionDelay: `${i * 0.1}s`
                        },
                        children: [
                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                style: {
                                    height: 8,
                                    background: YEAR_COLORS[year],
                                    borderRadius: 4,
                                    marginBottom: 14,
                                    boxShadow: expandedYear === i ? `0 0 24px ${YEAR_COLORS[year]}88` : `0 0 12px ${YEAR_COLORS[year]}44`,
                                    transition: "box-shadow 0.3s"
                                }
                            }),
                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                style: {
                                    fontFamily: "'Telia Sans', system-ui, sans-serif",
                                    fontSize: 24,
                                    fontWeight: 700,
                                    color: expandedYear === i ? YEAR_COLORS[year] : "#fff",
                                    textAlign: "center",
                                    transition: "color 0.3s"
                                },
                                children: year
                            })
                        ]
                    }, year))
            }),
            expandedYear !== null && (()=>{
                const year = yearKeys[expandedYear];
                const color = YEAR_COLORS[year];
                const data = ROADMAP[year];
                return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                    style: {
                        background: `${color}15`,
                        border: `1px solid ${color}44`,
                        borderRadius: 20,
                        padding: "28px 32px",
                        animation: "fadeSlideUp 0.4s ease"
                    },
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                fontFamily: "'Telia Sans', system-ui, sans-serif",
                                fontSize: 13,
                                color: color,
                                marginBottom: 22,
                                letterSpacing: 2,
                                textTransform: "uppercase"
                            },
                            children: [
                                year,
                                " Milestones"
                            ]
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "20px 32px"
                            },
                            children: CATEGORIES.map((cat)=>{
                                const items = data[cat.id] || [];
                                if (items.length === 0) return null;
                                return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                            style: {
                                                fontSize: 12,
                                                fontFamily: "'Telia Sans', system-ui, sans-serif",
                                                color: `${color}cc`,
                                                letterSpacing: 1,
                                                textTransform: "uppercase",
                                                marginBottom: 8,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 6,
                                                borderBottom: `1px solid ${color}33`,
                                                paddingBottom: 6
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                                    style: {
                                                        fontSize: 14
                                                    },
                                                    children: cat.icon
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: cat.label
                                                })
                                            ]
                                        }),
                                        items.map((item, j)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    gap: 10,
                                                    fontSize: 14,
                                                    color: "rgba(255,255,255,0.8)",
                                                    lineHeight: 1.6,
                                                    marginBottom: 4,
                                                    animation: "fadeSlideUp 0.3s ease",
                                                    animationDelay: `${j * 0.05}s`,
                                                    animationFillMode: "both"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                                        style: {
                                                            color: color,
                                                            fontSize: 8,
                                                            marginTop: 7,
                                                            flexShrink: 0
                                                        },
                                                        children: "\u25C6"
                                                    }),
                                                    item
                                                ]
                                            }, j))
                                    ]
                                }, cat.id);
                            })
                        })
                    ]
                });
            })(),
            expandedYear === null && /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    textAlign: "center",
                    color: "rgba(255,255,255,0.35)",
                    fontSize: 14,
                    fontStyle: "italic",
                    marginTop: 24
                },
                children: "Tap a year to explore milestones"
            })
        ]
    });
}
function $446ae9664652f266$var$ComparisonVisual({ active: active }) {
    const features = [
        {
            name: "Network Slicing",
            northstar: 95,
            public5g: 20
        },
        {
            name: "Indoor Positioning",
            northstar: 90,
            public5g: 10
        },
        {
            name: "IoT (RedCap/eRedCap)",
            northstar: 85,
            public5g: 20
        },
        {
            name: "API Exposure (CAMARA)",
            northstar: 80,
            public5g: 10
        },
        {
            name: "Low Latency (L4S)",
            northstar: 80,
            public5g: 5
        },
        {
            name: "V2X / Automotive",
            northstar: 75,
            public5g: 10
        },
        {
            name: "Edge Compute & AI",
            northstar: 70,
            public5g: 15
        },
        {
            name: "Outdoor 5G SA Positioning",
            northstar: 65,
            public5g: 5
        },
        {
            name: "ISAC / Sensing",
            northstar: 10,
            public5g: 0
        }
    ];
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            width: "100%",
            maxWidth: 720,
            margin: "0 auto"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 20,
                    marginBottom: 20,
                    fontSize: 12
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsxs)("span", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                style: {
                                    width: 12,
                                    height: 12,
                                    borderRadius: 3,
                                    background: `linear-gradient(135deg, ${$446ae9664652f266$var$TELIA_PURPLE}, ${$446ae9664652f266$var$TELIA_LIGHT})`,
                                    display: "inline-block"
                                }
                            }),
                            /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                style: {
                                    color: $446ae9664652f266$var$TELIA_LIGHT
                                },
                                children: "NorthStar"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsxs)("span", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                style: {
                                    width: 12,
                                    height: 12,
                                    borderRadius: 3,
                                    background: "#444",
                                    display: "inline-block"
                                }
                            }),
                            /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                style: {
                                    color: "#666"
                                },
                                children: "Public 5G"
                            })
                        ]
                    })
                ]
            }),
            features.map((f, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                    style: {
                        marginBottom: 18,
                        opacity: active ? 1 : 0,
                        transform: active ? "translateX(0)" : "translateX(-30px)",
                        transition: `all 0.5s ease ${i * 0.07}s`
                    },
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                fontFamily: "'Telia Sans', system-ui, sans-serif",
                                fontSize: 12,
                                color: "rgba(255,255,255,0.7)",
                                marginBottom: 6,
                                letterSpacing: 0.5
                            },
                            children: f.name
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 4
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        position: "relative",
                                        height: 14,
                                        background: "rgba(255,255,255,0.04)",
                                        borderRadius: 7,
                                        overflow: "hidden"
                                    },
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            height: "100%",
                                            width: active ? `${f.northstar}%` : "0%",
                                            background: `linear-gradient(90deg, ${$446ae9664652f266$var$TELIA_PURPLE}, ${$446ae9664652f266$var$TELIA_LIGHT})`,
                                            borderRadius: 7,
                                            transition: `width 1.2s cubic-bezier(0.16,1,0.3,1) ${0.3 + i * 0.07}s`,
                                            boxShadow: `0 0 16px ${$446ae9664652f266$var$TELIA_PURPLE}55`
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        position: "relative",
                                        height: 14,
                                        background: "rgba(255,255,255,0.04)",
                                        borderRadius: 7,
                                        overflow: "hidden"
                                    },
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            height: "100%",
                                            width: active ? `${f.public5g}%` : "0%",
                                            background: "#555",
                                            borderRadius: 7,
                                            transition: `width 1s ease ${0.3 + i * 0.07}s`
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }, f.name))
        ]
    });
}
function $446ae9664652f266$export$2e2bcd8739ae039() {
    const [activeSection, setActiveSection] = (0, $8XEkF.useState)(0);
    const [scrollProgress, setScrollProgress] = (0, $8XEkF.useState)(0);
    const containerRef = (0, $8XEkF.useRef)(null);
    const handleScroll = (0, $8XEkF.useCallback)(()=>{
        if (!containerRef.current) return;
        const el = containerRef.current;
        const scrollTop = el.scrollTop;
        const scrollHeight = el.scrollHeight - el.clientHeight;
        setScrollProgress(scrollTop / scrollHeight);
        const current = Math.round(scrollTop / el.clientHeight);
        if (current !== activeSection) setActiveSection(current);
    }, [
        activeSection
    ]);
    const scrollTo = (idx)=>{
        if (!containerRef.current) return;
        containerRef.current.scrollTo({
            top: idx * containerRef.current.clientHeight,
            behavior: "smooth"
        });
    };
    (0, $8XEkF.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        el.addEventListener("scroll", handleScroll);
        return ()=>el.removeEventListener("scroll", handleScroll);
    }, [
        handleScroll
    ]);
    const sectionStyle = {
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        padding: "40px 60px",
        scrollSnapAlign: "start",
        boxSizing: "border-box"
    };
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            width: "100%",
            height: "100vh",
            background: $446ae9664652f266$var$TELIA_DEEP,
            fontFamily: "'Telia Sans', system-ui, -apple-system, sans-serif",
            color: "#fff",
            overflow: "hidden",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("style", {
                children: `
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700&display=swap');
        @keyframes fadeSlideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%, 100% { opacity: 0.5; } 50% { opacity: 1; } }
        @keyframes glow { 0%, 100% { box-shadow: 0 0 20px ${$446ae9664652f266$var$TELIA_PURPLE}44; } 50% { box-shadow: 0 0 40px ${$446ae9664652f266$var$TELIA_PURPLE}88; } }
        * { scrollbar-width: none; } *::-webkit-scrollbar { display: none; }
      `
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$PurpleWaveBackground, {
                activeSection: activeSection
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "fixed",
                    right: 24,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 100,
                    display: "flex",
                    flexDirection: "column",
                    gap: 12
                },
                children: $446ae9664652f266$var$SECTIONS.map((s, i)=>/*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        onClick: ()=>scrollTo(i),
                        style: {
                            width: activeSection === i ? 14 : 8,
                            height: activeSection === i ? 14 : 8,
                            borderRadius: "50%",
                            background: activeSection === i ? $446ae9664652f266$var$TELIA_LIGHT : "rgba(255,255,255,0.2)",
                            cursor: "pointer",
                            transition: "all 0.3s",
                            boxShadow: activeSection === i ? `0 0 14px ${$446ae9664652f266$var$TELIA_LIGHT}88` : "none"
                        }
                    }, s))
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: 3,
                    zIndex: 100,
                    width: `${scrollProgress * 100}%`,
                    background: `linear-gradient(90deg, ${$446ae9664652f266$var$TELIA_PURPLE}, ${$446ae9664652f266$var$TELIA_LIGHT}, ${$446ae9664652f266$var$TELIA_MAGENTA})`,
                    transition: "width 0.1s"
                }
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                style: {
                    position: "fixed",
                    top: 16,
                    left: 24,
                    zIndex: 100,
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    opacity: 0.7
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$TeliaLogo, {
                        size: 50
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                        style: {
                            color: "rgba(255,255,255,0.2)",
                            fontSize: 20
                        },
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$EricssonLogo, {
                        size: 50
                    })
                ]
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                style: {
                    position: "fixed",
                    bottom: 16,
                    left: 24,
                    zIndex: 100,
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    opacity: 0.6
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$EULogo, {
                        size: 36
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsxs)("span", {
                        style: {
                            fontSize: 10,
                            color: "rgba(255,255,255,0.4)",
                            lineHeight: 1.3
                        },
                        children: [
                            "Co-funded by the",
                            /*#__PURE__*/ (0, $caV3w.jsx)("br", {}),
                            "European Union"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                ref: containerRef,
                style: {
                    height: "100vh",
                    overflowY: "auto",
                    scrollSnapType: "y mandatory",
                    position: "relative",
                    zIndex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: sectionStyle,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                textAlign: "center",
                                maxWidth: 900,
                                animation: "fadeSlideUp 1s ease"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontFamily: "'Telia Sans', system-ui, sans-serif",
                                        fontSize: 14,
                                        color: $446ae9664652f266$var$TELIA_LIGHT,
                                        letterSpacing: 5,
                                        marginBottom: 28,
                                        textTransform: "uppercase"
                                    },
                                    children: "5G SA Innovation Network"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("h1", {
                                    style: {
                                        fontSize: "clamp(52px, 9vw, 110px)",
                                        fontWeight: 700,
                                        margin: 0,
                                        lineHeight: 0.95,
                                        color: "#fff",
                                        letterSpacing: -3
                                    },
                                    children: "NorthStar"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("p", {
                                    style: {
                                        fontSize: 22,
                                        color: "rgba(255,255,255,0.55)",
                                        marginTop: 28,
                                        fontWeight: 400,
                                        lineHeight: 1.6
                                    },
                                    children: [
                                        "Sweden's purpose-built 5G Standalone innovation environment",
                                        /*#__PURE__*/ (0, $caV3w.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                            style: {
                                                fontSize: 16,
                                                color: "rgba(255,255,255,0.35)"
                                            },
                                            children: "By Telia and Ericsson \u2014 for industries shaping tomorrow"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: 40,
                                        marginTop: 52
                                    },
                                    children: [
                                        {
                                            n: 5,
                                            s: "+",
                                            l: "Industry Verticals"
                                        },
                                        {
                                            n: 99,
                                            s: ".9%",
                                            l: "5G Coverage"
                                        },
                                        {
                                            n: 2023,
                                            s: "",
                                            l: "Launched"
                                        }
                                    ].map((item, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                            style: {
                                                textAlign: "center",
                                                animation: "fadeSlideUp 1s ease",
                                                animationDelay: `${0.3 + i * 0.15}s`,
                                                animationFillMode: "both"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontFamily: "'Telia Sans', system-ui, sans-serif",
                                                        fontSize: 34,
                                                        fontWeight: 700,
                                                        color: $446ae9664652f266$var$TELIA_LIGHT
                                                    },
                                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$Counter, {
                                                        end: item.n,
                                                        suffix: item.s,
                                                        active: activeSection === 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: "rgba(255,255,255,0.35)",
                                                        marginTop: 6,
                                                        letterSpacing: 1
                                                    },
                                                    children: item.l
                                                })
                                            ]
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        marginTop: 64,
                                        animation: "pulse 2s infinite",
                                        color: "rgba(255,255,255,0.25)",
                                        fontSize: 13
                                    },
                                    children: "Scroll to explore \u2193"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: sectionStyle,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 820,
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontFamily: "'Telia Sans', system-ui, sans-serif",
                                        fontSize: 13,
                                        color: $446ae9664652f266$var$TELIA_MAGENTA,
                                        letterSpacing: 4,
                                        marginBottom: 20,
                                        textTransform: "uppercase",
                                        opacity: activeSection === 1 ? 1 : 0,
                                        transition: "opacity 0.5s"
                                    },
                                    children: "The Gap"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("h2", {
                                    style: {
                                        fontSize: "clamp(28px, 5vw, 50px)",
                                        fontWeight: 700,
                                        lineHeight: 1.2,
                                        margin: 0,
                                        opacity: activeSection === 1 ? 1 : 0,
                                        transform: activeSection === 1 ? "translateY(0)" : "translateY(30px)",
                                        transition: "all 0.6s ease"
                                    },
                                    children: [
                                        "Public 5G networks can't keep pace with",
                                        /*#__PURE__*/ (0, $caV3w.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                            style: {
                                                color: $446ae9664652f266$var$TELIA_MAGENTA
                                            },
                                            children: "industrial innovation"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("p", {
                                    style: {
                                        fontSize: 17,
                                        color: "rgba(255,255,255,0.5)",
                                        marginTop: 24,
                                        lineHeight: 1.7,
                                        opacity: activeSection === 1 ? 1 : 0,
                                        transition: "opacity 0.6s ease 0.3s"
                                    },
                                    children: "Sweden's commercial 5G excels at consumer broadband \u2014 but enterprises need network slicing, accurate positioning independent of GNSS, edge compute, ultra-low latency, and programmable APIs. Those features still aren't fully available in any Swedish public network."
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        gap: 18,
                                        marginTop: 40
                                    },
                                    children: [
                                        {
                                            icon: "\u26A1",
                                            title: "Limited or No Slicing",
                                            sub: "Granular use of QoS",
                                            desc: "Public networks aren't tailored to a variety use cases"
                                        },
                                        {
                                            icon: "\uD83D\uDCCD",
                                            title: "Limited or No Positioning",
                                            sub: "Adoption of 5G SA positioning",
                                            desc: "Mostly cell level positioning still being used"
                                        },
                                        {
                                            icon: "\uD83D\uDD12",
                                            title: "Central Traffic and Compute",
                                            sub: "Leveraging of traffic breakout",
                                            desc: "All data travels to distant clouds \u2014 no edge processing"
                                        }
                                    ].map((item, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                            style: {
                                                background: "rgba(255,255,255,0.03)",
                                                border: "1px solid rgba(255,255,255,0.06)",
                                                borderRadius: 18,
                                                padding: "28px 22px",
                                                textAlign: "center",
                                                opacity: activeSection === 1 ? 1 : 0,
                                                transform: activeSection === 1 ? "translateY(0)" : "translateY(20px)",
                                                transition: `all 0.5s ease ${0.4 + i * 0.1}s`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontSize: 30,
                                                        marginBottom: 14
                                                    },
                                                    children: item.icon
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontWeight: 700,
                                                        fontSize: 16,
                                                        marginBottom: 4
                                                    },
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontWeight: 400,
                                                        fontSize: 12,
                                                        color: "rgba(255,255,255,0.45)",
                                                        marginBottom: 12
                                                    },
                                                    children: item.sub
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontSize: 13,
                                                        color: "rgba(255,255,255,0.45)",
                                                        lineHeight: 1.55
                                                    },
                                                    children: item.desc
                                                })
                                            ]
                                        }, i))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: sectionStyle,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 860
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontFamily: "'Telia Sans', system-ui, sans-serif",
                                        fontSize: 13,
                                        color: $446ae9664652f266$var$TELIA_LIGHT,
                                        letterSpacing: 4,
                                        marginBottom: 20,
                                        textTransform: "uppercase",
                                        opacity: activeSection === 2 ? 1 : 0,
                                        transition: "opacity 0.5s"
                                    },
                                    children: "The Solution"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("h2", {
                                    style: {
                                        fontSize: "clamp(26px, 4.5vw, 46px)",
                                        fontWeight: 700,
                                        lineHeight: 1.2,
                                        margin: 0,
                                        opacity: activeSection === 2 ? 1 : 0,
                                        transform: activeSection === 2 ? "translateY(0)" : "translateY(30px)",
                                        transition: "all 0.6s ease"
                                    },
                                    children: [
                                        "A purpose-built 5G SA network",
                                        /*#__PURE__*/ (0, $caV3w.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                            style: {
                                                color: $446ae9664652f266$var$TELIA_LIGHT
                                            },
                                            children: "inside Telia's public infrastructure"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: 18,
                                        marginTop: 36
                                    },
                                    children: [
                                        {
                                            title: "Dual Core Architecture",
                                            desc: "Ericsson's 5G SA dual-mode core runs alongside Telia's commercial network \u2014 bleeding-edge features with nationwide reach.",
                                            color: $446ae9664652f266$var$TELIA_PURPLE
                                        },
                                        {
                                            title: "Network Slicing",
                                            desc: "Dedicated slices with custom 5QIs, DNNs, and radio resource partitions per use case \u2014 V2X, uRLLC, enterprise IoT.",
                                            color: $446ae9664652f266$var$TELIA_LIGHT
                                        },
                                        {
                                            title: "High-Precision Positioning",
                                            desc: "Indoor ~2m accuracy with AI-enhanced models, RTK over 5G for GNSS position correction, outdoor 5G SA Timing Advance/Uplink Angle of Arrival.",
                                            color: $446ae9664652f266$var$TELIA_MAGENTA
                                        },
                                        {
                                            title: "Edge Compute & AI Nodes",
                                            desc: "Local breakout, co-located compute, distributed AI inference at network edge across Sweden.",
                                            color: "#FFB74D"
                                        }
                                    ].map((item, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                            style: {
                                                background: `${item.color}0A`,
                                                border: `1px solid ${item.color}25`,
                                                borderRadius: 18,
                                                padding: "28px 24px",
                                                opacity: activeSection === 2 ? 1 : 0,
                                                transform: activeSection === 2 ? "translateY(0) scale(1)" : "translateY(20px) scale(0.98)",
                                                transition: `all 0.5s ease ${0.2 + i * 0.1}s`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        width: 8,
                                                        height: 8,
                                                        borderRadius: "50%",
                                                        background: item.color,
                                                        marginBottom: 16,
                                                        boxShadow: `0 0 14px ${item.color}88`
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontWeight: 600,
                                                        fontSize: 17,
                                                        marginBottom: 10
                                                    },
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontSize: 14,
                                                        color: "rgba(255,255,255,0.55)",
                                                        lineHeight: 1.65
                                                    },
                                                    children: item.desc
                                                })
                                            ]
                                        }, i))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: sectionStyle,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 800,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontFamily: "'Telia Sans', system-ui, sans-serif",
                                        fontSize: 13,
                                        color: "#FFB74D",
                                        letterSpacing: 4,
                                        marginBottom: 20,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        opacity: activeSection === 3 ? 1 : 0,
                                        transition: "opacity 0.5s"
                                    },
                                    children: "Beyond Public 5G"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("h2", {
                                    style: {
                                        fontSize: "clamp(24px, 4vw, 40px)",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        margin: "0 0 40px 0",
                                        opacity: activeSection === 3 ? 1 : 0,
                                        transform: activeSection === 3 ? "translateY(0)" : "translateY(20px)",
                                        transition: "all 0.5s ease"
                                    },
                                    children: "NorthStar vs. Sweden's Public 5G Networks"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$ComparisonVisual, {
                                    active: activeSection === 3
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: sectionStyle,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 950,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontFamily: "'Telia Sans', system-ui, sans-serif",
                                        fontSize: 13,
                                        color: $446ae9664652f266$var$TELIA_PURPLE,
                                        letterSpacing: 4,
                                        marginBottom: 20,
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        opacity: activeSection === 4 ? 1 : 0,
                                        transition: "opacity 0.5s"
                                    },
                                    children: "Roadmap 2025 \u2013 2029"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("h2", {
                                    style: {
                                        fontSize: "clamp(24px, 4vw, 40px)",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        margin: "0 0 36px 0",
                                        opacity: activeSection === 4 ? 1 : 0,
                                        transform: activeSection === 4 ? "translateY(0)" : "translateY(20px)",
                                        transition: "all 0.5s ease"
                                    },
                                    children: [
                                        "Feature-packed and ",
                                        /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                            style: {
                                                color: $446ae9664652f266$var$TELIA_PURPLE
                                            },
                                            children: "accelerating"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$RoadmapTimeline, {
                                    active: activeSection === 4
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: sectionStyle,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 820,
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontFamily: "'Telia Sans', system-ui, sans-serif",
                                        fontSize: 13,
                                        color: $446ae9664652f266$var$TELIA_ACCENT,
                                        letterSpacing: 4,
                                        marginBottom: 20,
                                        textTransform: "uppercase",
                                        opacity: activeSection === 5 ? 1 : 0,
                                        transition: "opacity 0.5s"
                                    },
                                    children: "Who's In"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("h2", {
                                    style: {
                                        fontSize: "clamp(24px, 4vw, 42px)",
                                        fontWeight: 700,
                                        margin: "0 0 12px 0",
                                        opacity: activeSection === 5 ? 1 : 0,
                                        transform: activeSection === 5 ? "translateY(0)" : "translateY(20px)",
                                        transition: "all 0.5s ease"
                                    },
                                    children: "From mines to battlefields"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("p", {
                                    style: {
                                        color: "rgba(255,255,255,0.45)",
                                        fontSize: 16,
                                        marginBottom: 36,
                                        opacity: activeSection === 5 ? 1 : 0,
                                        transition: "opacity 0.5s ease 0.2s"
                                    },
                                    children: "NorthStar brings together Sweden's most innovative organizations including"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        gap: 14
                                    },
                                    children: [
                                        {
                                            name: "AstaZero",
                                            sector: "Automotive R&D/Testing",
                                            desc: "Full-scale proving ground for autonomous driving and V2X testing"
                                        },
                                        {
                                            name: "Boliden",
                                            sector: "Mining",
                                            desc: "Underground 5G for autonomous vehicles in a constantly changing environment"
                                        },
                                        {
                                            name: "Karlstad University",
                                            sector: "Research",
                                            desc: "Advanced R&D in Low-Latency Communication and many other areas"
                                        },
                                        {
                                            name: "Lule\xe5 Technical University",
                                            sector: "Research",
                                            desc: "Advanced R&D in rural connectivity, AI and robotics"
                                        },
                                        {
                                            name: "Magna",
                                            sector: "Automotive Safety",
                                            desc: "Active vehicle safety solutions"
                                        },
                                        {
                                            name: "Region Stockholm",
                                            sector: "Healthcare",
                                            desc: "Indoor 5G solutions for positioning medical equipment"
                                        },
                                        {
                                            name: "RISE",
                                            sector: "Research",
                                            desc: "Edge AI computing for drones, agricultural robots and more"
                                        },
                                        {
                                            name: "Scania/Traton",
                                            sector: "Automotive",
                                            desc: "Solutions for autonomy in trucks and buses"
                                        },
                                        {
                                            name: "Swedish Armed Forces R&D (FOI)",
                                            sector: "Defense & NATO",
                                            desc: "Mission-critical 5G for communications"
                                        },
                                        {
                                            name: "Your Organization",
                                            sector: "Next?",
                                            desc: "Join the network shaping Sweden's industrial future"
                                        }
                                    ].map((p, i)=>{
                                        const isYou = p.name === "Your Organization";
                                        return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                            style: {
                                                background: isYou ? `${$446ae9664652f266$var$TELIA_PURPLE}18` : "rgba(255,255,255,0.03)",
                                                border: `1px solid ${isYou ? `${$446ae9664652f266$var$TELIA_PURPLE}55` : "rgba(255,255,255,0.06)"}`,
                                                borderRadius: 18,
                                                padding: "22px 18px",
                                                textAlign: "left",
                                                opacity: activeSection === 5 ? 1 : 0,
                                                transform: activeSection === 5 ? "translateY(0)" : "translateY(20px)",
                                                transition: `all 0.5s ease ${0.2 + i * 0.08}s`,
                                                animation: isYou && activeSection === 5 ? "glow 3s infinite" : "none"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontFamily: "'Telia Sans', system-ui, sans-serif",
                                                        fontSize: 10,
                                                        color: isYou ? $446ae9664652f266$var$TELIA_PURPLE : "rgba(255,255,255,0.3)",
                                                        letterSpacing: 2,
                                                        marginBottom: 8,
                                                        textTransform: "uppercase"
                                                    },
                                                    children: p.sector
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontWeight: 600,
                                                        fontSize: 16,
                                                        marginBottom: 8,
                                                        color: isYou ? $446ae9664652f266$var$TELIA_LIGHT : "#fff"
                                                    },
                                                    children: p.name
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                    style: {
                                                        fontSize: 13,
                                                        color: "rgba(255,255,255,0.4)",
                                                        lineHeight: 1.5
                                                    },
                                                    children: p.desc
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: sectionStyle,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 700,
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        fontSize: "clamp(34px, 6vw, 60px)",
                                        fontWeight: 700,
                                        lineHeight: 1.15,
                                        opacity: activeSection === 6 ? 1 : 0,
                                        transform: activeSection === 6 ? "translateY(0)" : "translateY(30px)",
                                        transition: "all 0.6s ease"
                                    },
                                    children: [
                                        "Ready to build on",
                                        /*#__PURE__*/ (0, $caV3w.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                            style: {
                                                background: `linear-gradient(135deg, ${$446ae9664652f266$var$TELIA_PURPLE}, ${$446ae9664652f266$var$TELIA_LIGHT}, ${$446ae9664652f266$var$TELIA_MAGENTA})`,
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent"
                                            },
                                            children: "Sweden's most advanced 5G?"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("p", {
                                    style: {
                                        fontSize: 17,
                                        color: "rgba(255,255,255,0.5)",
                                        marginTop: 24,
                                        lineHeight: 1.7,
                                        opacity: activeSection === 6 ? 1 : 0,
                                        transition: "opacity 0.6s ease 0.3s"
                                    },
                                    children: "Whether you're in automotive, mining, manufacturing, defense, or building something entirely new \u2014 NorthStar gives you features no public network can."
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: 16,
                                        marginTop: 40,
                                        opacity: activeSection === 6 ? 1 : 0,
                                        transition: "opacity 0.6s ease 0.5s"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsx)("a", {
                                            href: "/",
                                            style: {
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 8,
                                                padding: "14px 34px",
                                                background: `linear-gradient(135deg, ${$446ae9664652f266$var$TELIA_PURPLE}, ${$446ae9664652f266$var$TELIA_LIGHT})`,
                                                color: "#fff",
                                                borderRadius: 14,
                                                textDecoration: "none",
                                                fontWeight: 600,
                                                fontSize: 15,
                                                transition: "transform 0.2s, box-shadow 0.2s",
                                                border: "none"
                                            },
                                            onMouseEnter: (e)=>{
                                                e.currentTarget.style.transform = "translateY(-2px)";
                                                e.currentTarget.style.boxShadow = `0 8px 30px ${$446ae9664652f266$var$TELIA_PURPLE}55`;
                                            },
                                            onMouseLeave: (e)=>{
                                                e.currentTarget.style.transform = "translateY(0)";
                                                e.currentTarget.style.boxShadow = "none";
                                            },
                                            children: "Explore NorthStar \u2192"
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("a", {
                                            href: "mailto:northstar@teliacompany.com?subject=NorthStar%20Inquiry",
                                            style: {
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 8,
                                                padding: "14px 34px",
                                                background: "transparent",
                                                color: "rgba(255,255,255,0.6)",
                                                borderRadius: 14,
                                                border: "1px solid rgba(255,255,255,0.15)",
                                                textDecoration: "none",
                                                fontWeight: 500,
                                                fontSize: 15,
                                                transition: "all 0.2s"
                                            },
                                            onMouseEnter: (e)=>{
                                                e.currentTarget.style.borderColor = "rgba(255,255,255,0.4)";
                                                e.currentTarget.style.color = "#fff";
                                            },
                                            onMouseLeave: (e)=>{
                                                e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)";
                                                e.currentTarget.style.color = "rgba(255,255,255,0.6)";
                                            },
                                            children: "Contact the Team"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 28,
                                        marginTop: 60,
                                        opacity: 0.5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$TeliaLogo, {
                                            size: 60
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                            style: {
                                                color: "rgba(255,255,255,0.2)",
                                                fontSize: 18
                                            },
                                            children: "\xd7"
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$EricssonLogo, {
                                            size: 60
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                            style: {
                                                width: 1,
                                                height: 24,
                                                background: "rgba(255,255,255,0.1)"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $caV3w.jsx)($446ae9664652f266$var$EULogo, {
                                                    size: 28
                                                }),
                                                /*#__PURE__*/ (0, $caV3w.jsxs)("span", {
                                                    style: {
                                                        fontSize: 9,
                                                        color: "rgba(255,255,255,0.3)",
                                                        lineHeight: 1.3
                                                    },
                                                    children: [
                                                        "Co-funded by the",
                                                        /*#__PURE__*/ (0, $caV3w.jsx)("br", {}),
                                                        "European Union"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


const $c0906bb73369c37c$var$container = document.getElementById("presentation-root");
if ($c0906bb73369c37c$var$container) (0, $iERLf.createRoot)($c0906bb73369c37c$var$container).render(/*#__PURE__*/ (0, $caV3w.jsx)((0, $446ae9664652f266$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=northstar-presentation.f902e803.js.map
